module.exports = __webpack_public_path__ + "img/icon_robot.3128e13f.svg";